var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashDesksicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.138,
    height: 24.952,
    viewBox: "0 0 19.138 24.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M753.586,460.211c-1.315-1.65-2.591-3.245-3.861-4.844s-2.558-3.144-3.763-4.772a9.562,9.562,0,1,1,15.057.316c-2.358,3-4.743,5.973-7.117,8.957C753.819,459.971,753.722,460.063,753.586,460.211Zm-3.56-15.367a3.576,3.576,0,1,0,3.6-3.544A3.605,3.605,0,0,0,750.026,444.844Z",
    transform: "translate(-744.031 -435.259)",
    fill: "#fba800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashDesksicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/cashDesks.icon.24aa8453462cfb98a0b89f0c6d623983.svg";
export { ForwardRef as ReactComponent };